import { useTranslation } from 'react-i18next'
import { useClearRefinements, useCurrentRefinements } from 'react-instantsearch'
import { SansText } from '@velasca/ui/sans-text'
import { attributesForFaceting } from './AlgoliaFilters'
import {
  ActiveRefinementLabel,
  ClearRefinementsButton,
  ColorBackground,
  FlexContainer,
  FlexList,
  RemoveRefinementBadge,
  StyledClosedIcon,
} from './styles'

interface ActiveRefinementsProps {
  isSticky: boolean
}

export const ActiveRefinements = ({ isSticky }: ActiveRefinementsProps) => {
  const { t } = useTranslation('collection-filters')
  const { items, canRefine } = useCurrentRefinements()
  const { refine: clearRefinements } = useClearRefinements()

  return canRefine ? (
    <ColorBackground isSticky={isSticky}>
      <FlexContainer>
        <FlexList>
          <ActiveRefinementLabel>{t('selectedFilters')}:</ActiveRefinementLabel>
          {items.map(({ refinements, refine }) =>
            refinements.map((refinement) => {
              // TODO: evitare questa duplicazione e trasformarla in una funzione in utils
              const label = refinement.label.split('||')[0]
              const formattedLabel = label.replaceAll('-', ' ')

              const attribute = attributesForFaceting.find(
                (_attribute) => _attribute.attribute === refinement.attribute,
              )

              return (
                <RemoveRefinementBadge
                  key={refinement.label}
                  onClick={() => {
                    refine(refinement)
                  }}
                >
                  <StyledClosedIcon width="13" height="13" />
                  {attribute?.locale && (
                    <SansText fontWeight="500" margin={'0 0.5rem 0 0'}>
                      {t(attribute?.locale)}:
                    </SansText>
                  )}
                  <SansText>{formattedLabel}</SansText>
                </RemoveRefinementBadge>
              )
            }),
          )}
        </FlexList>
        <ClearRefinementsButton onClick={clearRefinements}>
          <StyledClosedIcon width="13" height="13" />
          {t('clearFilters')}
        </ClearRefinementsButton>
      </FlexContainer>
    </ColorBackground>
  ) : null
}
